<script setup lang="ts">
definePageMeta({
  layout: 'dynamic-page',
  middleware: ['dynamic-page-redirect'],
});
</script>

<template>
  <NuxtPage />
</template>
